import React, { Fragment } from "react";
import Header from "../components/Header";

import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PageHeader from "../components/PageHeader";
import Jobdetails from "../components/Jobdetails";
import Jobsection from "../components/Jobdetails/jobsection";
import ApplyForm from "../components/Jobdetails/applyform";

const JobsPage = () => {
  return (
    <Fragment>
      <Header />
      <PageHeader
        bgImg={require("../assets/img/jobsection-2.jpg")}
        title="In charge – OPD – Indore"
        content=""
      />
      <Jobsection />

      <Jobdetails />
      <ApplyForm />

      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default JobsPage;
